var map = {
	"./music-instructions.json": 4780,
	"./music-library-intro2024.json": 4781,
	"./music-library-launch2024.json": 4782,
	"./music-progression.json": 4783,
	"./startSourcesAdvanced.json": 4784,
	"./startSourcesSimple.json": 4785,
	"./startSourcesSimple2.json": 4786,
	"./startSourcesTracks.json": 4787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4498;